import { getCoreDataSecurityAlertsSlice } from './get';
import { postDataSecurityAlert } from '@api/data-security';

import { createPostAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const postCoreDataSecurityAlertSlice = createPostAsyncSlice({
	httpSagaOptions: {
		successActionCreators: [
			getCoreDataSecurityAlertsSlice.asyncActionCreators.repeatGetCoreDataSecurityAlerts
		]
	},
	name: 'CoreDataSecurityAlert',
	receive: false,
	request: true,
	requestHandler: postDataSecurityAlert,
	yieldType: SagaYieldType.Latest
});
